import { useEffect, useState } from "react";

import { getGoogleStreetViewMetadata } from "../api";
import {
  calculateHeadingFromCoordinates,
  getValidCoordinates,
} from "../streetView";

export default function useStreetViewHeading({
  open,
  latitude,
  longitude,
  apiKey,
}) {
  const [heading, setHeading] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const targetCoordinates = getValidCoordinates({ latitude, longitude });

    if (!open || !apiKey || !targetCoordinates) {
      setHeading(null);
      return () => {
        isCancelled = true;
      };
    }

    const resolveHeading = async () => {
      const metadata = await getGoogleStreetViewMetadata({
        latitude: targetCoordinates.latitude,
        longitude: targetCoordinates.longitude,
        apiKey,
      });

      if (isCancelled) {
        return;
      }

      const panoLatitude = metadata?.location?.lat;
      const panoLongitude = metadata?.location?.lng;

      const nextHeading = calculateHeadingFromCoordinates({
        fromLatitude: panoLatitude,
        fromLongitude: panoLongitude,
        toLatitude: targetCoordinates.latitude,
        toLongitude: targetCoordinates.longitude,
      });

      setHeading(nextHeading);
    };

    resolveHeading();

    return () => {
      isCancelled = true;
    };
  }, [apiKey, latitude, longitude, open]);

  return heading;
}
